import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/*
 * tailwind-merge only knows Tailwind's default font sizes. Our type scale
 * (tailwind.config.ts `fontSize`) uses custom names, so without this it
 * classifies `text-subhead` / `text-headline` as COLOURS — and silently drops
 * either the size or the real colour (`text-ink-secondary`, `text-on-accent`)
 * whenever both appear in one `cn()` call (every Button variant + size).
 * Keep this list equal to the fontSize keys.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        {
          text: [
            'display',
            'display-sm',
            'section',
            'headline',
            'subhead',
            'body',
            'caption',
            'kicker',
            'micro',
            'wordmark',
          ],
        },
      ],
    },
  },
});

/** Merge conditional class names, de-duping conflicting Tailwind utilities. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
